module.exports = __webpack_public_path__ + "static/media/red-flag.19e683cd.svg";